<template>
  <div class="home-page">
    <div class="first-box" ref="firstBox">
      <img class="main-logo" src="../../../public/static/indexUse/logo.png" alt="AIJU SCHOOL" />
      <div class="explore-more" @click="scrollToSecond">
        <span>{{ $t('探索更多') }}</span>
        <dol-icon type="DownOutlined" />
      </div>
    </div>

    <div class="second-box">
      <div class="box-container">
        <div class="left-content">
          <div>
            <h2 class="title">{{ $t('爱知博艺 菊雅竞芳') }}</h2>
            <p class="desc">{{ $t('在爱菊') }}</p>
          </div>
          <div class="tag-list">
            <div v-for="tag in tagList" :key="tag.id" class="tag-item" :class="`tag-${tag.id}`">
              <div class="tag-name">{{ $t(tag.name) }}</div>
              <div class="tag-desc">{{ $t(tag.desc) }}</div>
            </div>
          </div>
        </div>
        <div class="right-content" v-if="!isMobile">
          <img class="campus-img" src="../../../public/static/indexUse/index-1.jpg" alt="校园生活" />
          <div class="img-desc-box">
            <div class="img-title">{{ $t('校园生活') }}</div>
            <div class="img-desc">{{ $t('校园坐落') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="third-box">
      <div class="third-container">
        <div class="third-title">{{ $t('爱菊教育') }}</div>
        <a-row :gutter="[6,6]" v-if="isMobile">
          <a-col v-for="item in eduList" :key="item._id" :span="12">
            <div class="edu-item" @click="$router.push(item.page?.link || item.page?._id)">
              <img class="edu-img" :src="getImagePath(item)" />
              <div class="edu-text">{{ $dt(item.page, 'name') }}</div>
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="[12,12]" v-else>
          <a-col v-for="item in eduList" :key="item._id" :span="item.span">
            <div class="edu-item" @click="$router.push(item.page?.link || item.page?._id)">
              <img class="edu-img" :src="getImagePath(item)" />
              <div class="edu-text">{{ $dt(item.page, 'name') }}</div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>

    <div class="fourth-box" v-if="newsShow">
      <div class="fourth-container">
        <div class="fourth-title">{{ $t('新闻与活动') }}</div>
        <a-row class="news-list" :gutter="isMobile?[12,12]:[24,24]">
          <a-col :span="isMobile?24:8" v-for="item in newsList" :key="item._id">
            <div class="news-item" @click="goNewsDetail(item)">
              <img class="news-img" :src="newsImageSrc(item)" :style="newsImageStyle(item)" />
              <div class="news-title">{{ $dt(item, 'title') }}</div>
              <div class="news-content">{{ $dt(item, 'remark') }}</div>
              <div class="news-createTime">{{ $dayjs(item.updateTime).format('YYYY-MM-DD') }}</div>
            </div>
          </a-col>
        </a-row>
        <div class="button-row">
          <div class="as-button" @click="$router.push('/news')">{{ $t('查看更多') }}</div>
        </div>
      </div>
    </div>

    <template v-if="!isMobile && (adInfo2 || adInfo)">
      <!--      {{adInfo}}-->
      <div class="ad-area">
        <div class="ad2-image-box" v-if="adInfo2 && ad2Open">
          <div class="ad2-close-btn" @click="ad2Open = false">×</div>
          <img class="ad2-image" :src="getImagePath(adInfo2)" :style="{ width: ad2Width }" @click="ad2Jump" />
        </div>
        <template v-if="adInfo">
          <div class="ad-open" v-if="adOpen">
            <div class="ad-close-btn" @click="adOpen = false">×</div>
            <img class="ad-img" :src="$Dolphin.path.publicPath + adInfo.backgroundImage?.filePath" />
            <!--        <div class="ad-box">-->
            <div class="ad-open-inside">
              <div class="ad-title" v-if="adInfo.name"> {{ $dt(adInfo, 'title') }}</div>
              <img class="ad-image" :src="getImagePath(adInfo)" />
            </div>
            <!--        </div>-->
          </div>
          <div class="ad-close" v-else @click="adOpen = true">
            <img :src="$Dolphin.path.publicPath + adInfo.backgroundImage?.filePath" />
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: "home",
  data() {
    return {
      adOpen: false,
      adInfo: null,
      ad2Open: false,
      adInfo2: null,
      tagList: [
        { id: 1, name: '爱知', desc: '热爱知识，夯实基础' },
        { id: 2, name: '博艺', desc: '通晓科艺，增长才干' },
        { id: 3, name: '菊雅', desc: '举止优雅，高雅情趣' },
        { id: 4, name: '竞芳', desc: '合作自信，全面发展' },
      ],
      isScrolling: false,
      newsList: [],
      eduList: [],
      newsShow: true,
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.app.isMobile;
    },
    ad2Width() {
      // title 字段作为广告2图片宽度配置（如 "320px"），无效时使用默认宽度
      const title = (this.adInfo2?.title || '').trim();
      return /^\d+(\.\d+)?\s*(px|%|rem|vw|em)?$/i.test(title) ? title : '360px';
    }
  },
  methods: {
    newsImageSrc(item) {
      const image = this.$dt(item, 'image') || item.image;
      return image?.filePath ? this.$Dolphin.path.publicPath + image.filePath : '';
    },
    newsImageStyle(item) {
      return { objectFit: item.objectFit || 'cover' }
    },
    scrollToSecond() {
      // this.$refs.secondBox.scrollIntoView({ behavior: 'smooth' });

      const headerHeight = this.isMobile ? 60 : 80; // 对应header的固定高度80px
      const boxHeight = this.$refs.firstBox.offsetHeight;
      this.$emit('homeScrollToSecond', headerHeight + boxHeight - 76)
    },
    queryNews() {
      this.$ajax({
        url: '/portal/newsList',
        method: 'post',
        data: { type: '', searchStr: '' },
        params: { pageNumber: 0, pageSize: 3 }
      }).then(({ rows }) => {
        this.newsList = rows;
      })
    },
    goNewsDetail(item) {
      if (item.linkType === 'out') {
        window.open(item.link);
      } else {
        this.$router.push(`/newsDetail?id=${item._id}`);
      }
    },
    queryEdu() {
      this.$ajax({ url: '/portal/homeEduFind', }).then(({ rows }) => {
        this.eduList = rows;
      });
    },
    getImagePath(item) {
      const image = this.$dt(item, 'image') || item.image;
      if (!image) return '';
      return this.$Dolphin.path.publicPath + image.filePath;
    },
    queryAd() {
      this.$ajax({ url: '/portal/queryCommonConfig', params: { code: 'homeAd' } }).then(({ rows }) => {
        const data = rows[0];
        this.adInfo = data;
        this.adOpen = !!data;
      });
    },
    queryAd2() {
      this.$ajax({ url: '/portal/queryCommonConfig', params: { code: 'homeAd2' } }).then(({ rows }) => {
        const data = rows[0];
        this.adInfo2 = data;
        this.ad2Open = !!data;
      });
    },
    ad2Jump() {
      if (this.adInfo2?.content) {
        window.open(this.adInfo2.content);
      }
    },
    queryHomeNews() {
      this.$ajax({ url: '/portal/queryCommonConfig', params: { code: 'homeNews' } }).then(({ rows }) => {
        this.newsShow = !!rows[0];
      });
    },
  },
  created() {
    this.queryNews();
    this.queryEdu();
    this.queryAd();
    this.queryAd2();
    this.queryHomeNews();
  },
  mounted() {
    // window.addEventListener('wheel', this.handleWheel, { passive: false });
    this.$emit('scrollToTop');
  },
  activated() {
    this.$emit('scrollToTop');
  },
  beforeUnmount() {
    // window.removeEventListener('wheel', this.handleWheel);
  },
};
</script>

<style scoped lang="scss">
@use '../../assets/scss/constant' as constant;

.home-page {
  width: 100%;

  .ad-area {
    position: fixed;
    right: 0;
    bottom: 120px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 16px;
    z-index: 10;
  }

  .ad2-image-box {
    position: relative;

    .ad2-close-btn {
      position: absolute;
      right: 0;
      top: 0;
      padding: 8px;
      cursor: pointer;
      font-size: 16px;
      color: white;
      line-height: 1;
      z-index: 1;
    }

    .ad2-image {
      display: block;
      cursor: pointer;
    }
  }

  .ad-open {
    position: relative;
    width: 180px;
    // 背景渐变色 上5AA1FF 下E5F0FF
    background: linear-gradient(180deg, #5AA1FF 0%, #E5F0FF 100%);
    padding: 8px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .ad-img {
      width: 80%;
      //margin-bottom: 4px;
    }

    .ad-close-btn {
      position: absolute;
      right: 0;
      top: 0;
      padding: 8px;
      cursor: pointer;
      font-size: 16px;
      color: white;
    }

    .ad-open-inside {
      background: linear-gradient(180deg, #DDECFF 0%, #FFFFFF 100%);
      padding: 12px;
      border-radius: 12px;
    }

    .ad-title {
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: #003C82;
      margin-bottom: 6px;
    }

    .ad-image {
      width: 100%;
    }
  }

  .ad-close {
    width: 100px;
    height: 100px;
    padding: 0 4px;
    border-radius: 50% 0 0 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #1a7cfe;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .first-box {
    width: 100%;
    height: 700px;
    background: url("../../../public/static/indexUse/bg.png") no-repeat center / cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .main-logo {
      height: 220px;
      width: auto;
      object-fit: contain;
    }

    .explore-more {
      position: absolute;
      bottom: 32px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      transition: opacity 0.3s ease;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .second-box {
    width: 100%;
    margin: 96px 0;
    box-sizing: border-box;

    .box-container {
      width: 1280px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 120px;

      .left-content {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .title {
          font-size: 22px;
          font-weight: bold;
          color: #003C82;
          margin: 0 0 16px 0;
          line-height: 1.4;
        }

        .desc {
          font-size: 14px;
          color: #333;
          line-height: 1.6;
          margin: 0 0 40px 0;
        }

        .tag-list {
          display: flex;
          flex-wrap: wrap;

          .tag-item {
            width: 50%;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;

            .tag-name {
              width: 120px;
              height: 120px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 32px;
              font-weight: bold;
              margin: 0 12px 16px;
              text-align: center;
            }

            .tag-desc {
              width: 100%;
              font-size: 16px;
              text-align: center;
              margin-bottom: 36px;
            }

            &.tag-1 {
              color: #CD497E;

              .tag-name {
                background: rgba(#CD497E, 0.2);
              }
            }

            &.tag-2 {
              color: #5D9947;

              .tag-name {
                background: rgba(#5D9947, 0.2);
              }
            }

            &.tag-3 {
              color: #DEA128;

              .tag-name {
                background: rgba(#DEA128, 0.2);
              }
            }

            &.tag-4 {
              color: #32689E;

              .tag-name {
                background: rgba(#32689E, 0.2);
              }
            }
          }
        }
      }

      .right-content {
        flex: 1;
        position: relative;
        height: 650px;
        display: flex;
        align-items: center;

        .campus-img {
          width: 100%;
          height: 100%;
        }

        .img-desc-box {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 230px;
          padding: 30px 158px 30px 32px;
          background: linear-gradient(180deg, rgba(0, 60, 130, 0) 0%, #003C82 100%);
          color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;

          .img-title {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 12px;
          }

          .img-desc {
            font-size: 16px;
            line-height: 1.5;
          }
        }
      }
    }
  }

  .third-box {
    background: url("../../../public/static/indexUse/thirdBg.png") no-repeat center / cover;
    padding: 96px 0;

    .third-container {
      width: 1280px;
      margin: auto;

      .third-title {
        font-weight: 600;
        font-size: 32px;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: 32px;
      }

      .edu-item {
        position: relative;
        transition: all 0.2s ease;
        cursor: pointer;
        height: 100%;

        &:hover {
          transform: scale(1.02);
          box-shadow: 0 16px 32px rgba(0, 30, 70, 0.25), 0 8px 16px rgba(0, 30, 70, 0.18);
          z-index: 10;
        }
      }

      .edu-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .edu-text {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        display: flex;
        align-items: flex-end;
        padding: 32px;
        font-weight: 600;
        font-size: 20px;
        color: #FFFFFF;
      }
    }
  }

  .fourth-box {
    background-color: white;
    padding: 96px 0;

    .fourth-container {
      width: 1280px;
      margin: auto;

      .fourth-title {
        font-size: 32px;
        color: #003C82;
        margin-bottom: 24px;
        font-weight: bold;
      }

      .no-data {
        color: #999999;
        padding: 24px;
        font-size: 16px;
        text-align: center;
      }

      .news-item {
        position: relative;
        cursor: pointer;
        height: 100%;
      }

      .news-img {
        width: 100%;
        height: 280px;
        object-fit: cover;
        object-position: center;
        margin-bottom: 16px;
      }

      .news-title {
        font-size: 20px;
        color: #003C82;
        line-height: 28px;
        font-weight: bold;
        margin-bottom: 8px;
        white-space: pre-wrap;
      }

      .news-content {
        color: #333333;
        line-height: 20px;
        margin-bottom: 8px;
        white-space: pre-wrap;
      }

      .news-createTime {
        color: #999999;
        line-height: 20px;
      }
    }

    .button-row {
      display: flex;
      justify-content: center;
      margin-top: 36px;

      .as-button {
        display: inline-block;
        padding: 22px 74px;
        background-color: #003C82;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 28px;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }
}

// PC端
@media (min-width: #{constant.$mobileMaxWidth + 1}) {
  .home-page {
  }
}

// 移动端
@media (max-width: constant.$mobileMaxWidth) {
  .home-page {
    .first-box {
      width: 100%;
      height: 460px;

      .main-logo {
        height: 160px;
      }
    }

    .second-box {
      margin: 0;
      padding: 24px;

      .box-container {
        width: 100%;

        .left-content {
          .title {
            font-size: 18px;
          }

          .tag-list {
            .tag-item {
              .tag-name {
                width: 100px;
                height: 100px;
                font-size: 24px;
                margin: 0 12px 12px;
              }

              .tag-desc {
                font-size: 14px;
                margin-bottom: 24px;
              }
            }
          }
        }
      }
    }

    .third-box {
      padding: 24px;

      .third-container {
        width: 100%;

        .third-title {
          font-size: 18px;
          margin-bottom: 12px;
        }

        .edu-text {
          padding: 12px;
          font-size: 16px;
        }
      }
    }

    .fourth-box {
      padding: 24px;

      .fourth-container {
        width: 100%;

        .fourth-title {
          font-size: 18px;
          margin-bottom: 12px;
        }

        .no-data {
          font-size: 14px;
        }

        .news-img {
          height: 240px;
          margin-bottom: 8px;
        }

        .news-title {
          font-size: 16px;
          line-height: 20px;
        }

        .news-createTime {
          color: #999999;
          line-height: 20px;
        }
      }

      .button-row {
        margin-top: 24px;

        .as-button {
          padding: 8px 24px;
          font-size: 16px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
